module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921071149_T.d4fabc7d.jpg";